import { use } from 'react'

import type { AppContextType } from 'aem-libs-react-components/src/contexts/AppContextProvider'
import { AppContext } from 'aem-libs-react-components/src/contexts/AppContextProvider'

import LanguageDetector from '../services/LanguageDetector'
import type AppConfig from '../types/app-config'
import type { Language } from '../types/common'


interface UseAppContextReturn<TStaticParams, TDynamicParams, TParamsFile>
  extends Required<Omit<AppContextType, 'paramsFile' | 'paramsStatic' | 'paramsDynamic'>> {
  language: Language
  paramsStatic: TStaticParams
  paramsDynamic: TDynamicParams
  paramsFile: TParamsFile
}

export function useAppContext<
  TStaticParams = unknown,
  TDynamicParams = unknown,
  TParamsFile = AppConfig
>(): UseAppContextReturn<TStaticParams, TDynamicParams, TParamsFile> {
  const { paramsStatic, paramsDynamic, paramsFile, ...contextData } = use(AppContext)
  return {
    language: LanguageDetector(),
    paramsStatic: paramsStatic as TStaticParams,
    paramsDynamic: paramsDynamic as TDynamicParams,
    paramsFile: paramsFile as unknown as TParamsFile,
    ...(contextData as Required<Omit<AppContextType, 'paramsFile' | 'paramsStatic' | 'paramsDynamic'>>)
  }
}
